import type { QuestionProps } from '../eform.types'

export default function OptInToggles({ value, onChange }: QuestionProps) {
  const strValue = Array.isArray(value) ? value[0] ?? '1|1|1|1' : value || '1|1|1|1'
  const parts = strValue.split('|')

  const values = [
    parts[0] === '1',
    parts[1] === '1',
    parts[2] === '1',
    parts[3] === '1',
  ]

  function toggle(index: number) {
    const newParts = [...parts]
    newParts[index] = newParts[index] === '1' ? '0' : '1'
    onChange(newParts.join('|'))
  }

  return (
    <div className="space-y-4">
      {/* Transactional */}
      <div>
        <div className="flex items-baseline gap-2 mb-2">
          <p className="text-sm font-semibold text-slate-800">Transactional</p>
          <p className="text-xs text-slate-500">– Appointment confirmations, receipts, and account notifications.</p>
        </div>
        <div className="flex items-center gap-6">
          <ToggleRow label="Email" checked={values[0]} onToggle={() => toggle(0)} />
          <ToggleRow label="SMS" checked={values[1]} onToggle={() => toggle(1)} />
        </div>
      </div>

      {/* Marketing */}
      <div>
        <div className="flex items-baseline gap-2 mb-2">
          <p className="text-sm font-semibold text-slate-800">Marketing</p>
          <p className="text-xs text-slate-500">– Promotional offers, newsletters, and campaign messages.</p>
        </div>
        <div className="flex items-center gap-6">
          <ToggleRow label="Email" checked={values[2]} onToggle={() => toggle(2)} />
          <ToggleRow label="SMS" checked={values[3]} onToggle={() => toggle(3)} />
        </div>
      </div>
    </div>
  )
}

function ToggleRow({ label, checked, onToggle }: { label: string; checked: boolean; onToggle: () => void }) {
  return (
    <div className="flex items-center gap-1.5">
      <span className="text-sm text-slate-700">{label}</span>
      <button
        type="button"
        role="switch"
        aria-checked={checked}
        onClick={onToggle}
        className={`relative inline-flex h-6 w-11 shrink-0 items-center rounded-full transition-colors focus:outline-none focus:ring-2 focus:ring-primary/30 ${
          checked ? 'bg-blue-600' : 'bg-gray-300'
        }`}
      >
        <span
          className={`inline-block h-4 w-4 transform rounded-full bg-white shadow transition-transform ${
            checked ? 'translate-x-6' : 'translate-x-1'
          }`}
        />
      </button>
      <span className={`text-xs font-medium w-7 ${checked ? 'text-blue-600' : 'text-slate-400'}`}>
        {checked ? 'On' : 'Off'}
      </span>
    </div>
  )
}
